/* JC Stays - theme-vc - Wright's Mansion property page
   Modal scroll-lock + photo indicator + Leaflet map.
   Header / drawer / dropdown init lives in main.js.
   Header-scroll guard for is-modal-open also handled here defensively.
*/
(function () {
    'use strict';

    function safeInit(name, fn) {
        try { fn(); }
        catch (err) { console.error('[wm-page] init "' + name + '" failed:', err); }
    }

    /* Re-bind header-scroll with modal guard. Theme main.js installs an
       unguarded version; this overrides for pages with modals. */
    function initHeaderScrollGuarded() {
        var header = document.querySelector('.site-header');
        if (!header) return;
        var onScroll = function () {
            if (document.body.classList.contains('is-modal-open')) return;
            header.classList.toggle('is-scrolled', window.scrollY > 60);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    function initMap() {
        var el = document.getElementById('property-map');
        if (!el || typeof L === 'undefined') return;
        var lat = parseFloat(el.getAttribute('data-lat')) || 43.4553;
        var lng = parseFloat(el.getAttribute('data-lng')) || -76.5105;
        var map = L.map(el, {
            center: [lat, lng],
            zoom: 13,
            scrollWheelZoom: false,
            zoomControl: true,
            attributionControl: true,
        });
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 19,
        }).addTo(map);
        L.circle([lat, lng], {
            color: '#3A554E',
            fillColor: '#4F6E66',
            fillOpacity: 0.18,
            weight: 2,
            radius: 600,
        }).addTo(map);
    }

    function initModals() {
        /* Background scroll lock strategy: block events + continuous scroll
           enforcer. CSS overflow approaches break because the global
           body { overflow-x: clip } interacts with shorthand changes and
           triggers Chromium's snap-to-top bug. */
        var savedScrollY = 0;
        var enforcing = false;

        function blockScrollEvents(e) {
            if (e.target.closest && e.target.closest('dialog.modal[open]')) return;
            e.preventDefault();
        }
        var scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'];
        function blockScrollKeys(e) {
            if (scrollKeys.indexOf(e.key) === -1) return;
            if (e.target.closest && e.target.closest('dialog.modal[open]')) return;
            e.preventDefault();
        }
        function enforceScrollY() {
            if (enforcing) return;
            if (window.scrollY !== savedScrollY) {
                enforcing = true;
                window.scrollTo(0, savedScrollY);
                requestAnimationFrame(function () { enforcing = false; });
            }
        }

        function lockBodyScroll() {
            if (document.body.classList.contains('is-modal-open')) return;
            savedScrollY = window.scrollY || window.pageYOffset || 0;
            document.addEventListener('wheel', blockScrollEvents, { passive: false });
            document.addEventListener('touchmove', blockScrollEvents, { passive: false });
            document.addEventListener('keydown', blockScrollKeys);
            window.addEventListener('scroll', enforceScrollY, { passive: true });
            document.body.classList.add('is-modal-open');
        }

        function unlockBodyScroll() {
            if (!document.body.classList.contains('is-modal-open')) return;
            document.body.classList.remove('is-modal-open');
            document.removeEventListener('wheel', blockScrollEvents, { passive: false });
            document.removeEventListener('touchmove', blockScrollEvents, { passive: false });
            document.removeEventListener('keydown', blockScrollKeys);
            window.removeEventListener('scroll', enforceScrollY);
            if (window.scrollY !== savedScrollY) {
                window.scrollTo(0, savedScrollY);
            }
        }

        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-modal-open]');
            if (trigger) {
                var id = trigger.getAttribute('data-modal-open');
                var dialog = document.getElementById(id);
                if (dialog && typeof dialog.showModal === 'function') {
                    e.preventDefault();
                    lockBodyScroll();
                    dialog.showModal();
                    if (window.scrollY !== savedScrollY) {
                        window.scrollTo(0, savedScrollY);
                    }
                    var inner = dialog.querySelector('.modal__inner');
                    if (inner) inner.scrollTop = 0;
                    dialog.scrollTop = 0;
                }
                return;
            }
            var closer = e.target.closest('[data-modal-close]');
            if (closer) {
                var d = closer.closest('dialog');
                if (d) d.close();
                return;
            }
            if (e.target.tagName === 'DIALOG') {
                e.target.close();
            }
        });

        document.querySelectorAll('dialog.modal').forEach(function (d) {
            d.addEventListener('close', function () {
                if (!document.querySelector('dialog.modal[open]')) {
                    unlockBodyScroll();
                }
            });
        });
    }

    function initPhotoIndicator() {
        var strip = document.querySelector('.property-photos__collage');
        var current = document.querySelector('.property-photos__indicator-current');
        if (!strip || !current) return;
        function pad(n) { return n < 10 ? '0' + n : String(n); }
        function update() {
            var w = strip.clientWidth;
            if (w === 0) return;
            var idx = Math.round(strip.scrollLeft / w) + 1;
            current.textContent = pad(Math.max(1, Math.min(11, idx)));
        }
        strip.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    function boot() {
        safeInit('headerScrollGuarded', initHeaderScrollGuarded);
        safeInit('modals', initModals);
        safeInit('photoIndicator', initPhotoIndicator);
        if (document.readyState === 'complete') {
            safeInit('map', initMap);
        } else {
            window.addEventListener('load', function () { safeInit('map', initMap); });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
